module.exports = __webpack_public_path__ + "img/wxguanzhu.f53d4e6c.jpg";